import React, { useEffect, useState } from 'react'
import {
  Toolbar,
  IconButton,
  AppBar,
  Typography,
  Box,
  useTheme
} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import { any, func, string, array } from 'prop-types'
import UserProfile from '../UserProfile'
import GetPageName from './GetPageName'
import RegressiveCounter from '../../regressiveCounter'
import BaseTooltip from '../../../components/BaseTooltip'
import axios from 'axios'
import { useKeycloak } from '@react-keycloak/web'
const PainelAppbar = ({ drawerWidth, actionToggle, sectionSize, routes }) => {
  const theme = useTheme()
  const [isExemplar, setIsExemplar] = useState(false)
  const [base64Image, setBase64Image] = useState('')
  const { keycloak } = useKeycloak()
  const toggleDreawer = () => {
    actionToggle()
  }

  const AppbarStyles = {
    width: { sm: `calc(100% - ${drawerWidth}px)` },
    ml: { sm: `${drawerWidth}px` },
    color: theme.palette.secondary.main,
    boxShadow: 'none',
    backgroundColor: theme.palette.background.main
  }

  const BoxStyles = {
    width: { sm: sectionSize },
    margin: { sm: '0 auto' },
    boxShadow:
      '1px -1px 2px rgba(0, 0, 0, 0.25), 1px 1px 1px rgba(0, 0, 0, 0.25)',
    borderRadius: '5px',
    backgroundColor: theme.palette.leitura.main,
    color: theme.palette.secondary.main
  }

  useEffect(() => {
    fetchImageUser()
  }, [])

  function fetchImageUser() {
    axios
      .get(process.env.REACT_APP_API_BIRTHDAY, {
        params: {
          cpf: keycloak.tokenParsed.cpf
        }
      })
      .then(response => {
        const { data } = response.data

        const base64String = data[0].imagem

        setBase64Image(formatImage(base64String))
      })
      .catch(error => {
        console.error('Erro ao buscar dados:', error)
      })
  }

  function formatImage(base64String) {
    const bytesPng =
      'iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC'

    if (base64String.includes(bytesPng)) {
      return 'data:image/png;base64,' + base64String
    }
    return 'data:image/jpeg;base64,' + base64String
  }

  return (
    <AppBar position="fixed" sx={AppbarStyles}>
      <Box sx={BoxStyles}>
        <Toolbar>
          <IconButton
            color="white"
            aria-label="open drawer"
            edge="start"
            onClick={toggleDreawer}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            style={{
              color: 'white',
              textTransform: 'capitalize',
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
              fontSize: isExemplar ? '18px' : '24px'
            }}
            variant="h5"
            noWrap
            component="div"
          >
            <GetPageName
              isExemplar={isExemplar}
              routes={routes}
              onTest={value => setIsExemplar(value)}
            />
            <div className="d-flex">
              <BaseTooltip light title="Dias até a próxima postagem">
                <RegressiveCounter />
              </BaseTooltip>
              <UserProfile avatar={base64Image} />
            </div>
          </Typography>
        </Toolbar>
      </Box>
    </AppBar>
  )
}

PainelAppbar.propTypes = {
  drawerWidth: any,
  actionToggle: func,
  sectionSize: string,
  routes: array
}
export default PainelAppbar
